import { render } from "./page_context_menu.vue?vue&type=template&id=1742af49"
import script from "./page_context_menu.vue?vue&type=script&lang=js"
export * from "./page_context_menu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__